"use client";

import { useRouter, useSearchParams } from "next/navigation";
import MainPage from "./main-page/page";
import { Suspense, useEffect } from "react";
import { useMessage } from "./messageContext";

const Component = () => {
  const messageApi = useMessage();
  const router = useRouter();
  const params = useSearchParams();

  useEffect(() => {
    const requiredParams = [
      'OutSum',
      'InvId',
      'SignatureValue'
    ];

    for (const param of requiredParams) {
      if (!params.has(param)) {
        router.replace('/');
        return;
      }
    }

    if (params && params.toString()) {
      router.replace('/');
      messageApi.open({ type: "success", content: "Заказ принят" });
    }
  }, [params, router, messageApi]);

  return <MainPage />;
};

export default function Home() {
  return (
    <Suspense>
      <Component />
    </Suspense>
  );
}